import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Loader2, ShieldAlert, Lock } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ProgrammePage() {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const key = searchParams.get('key');
  const [html, setHtml] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!key) { setError('nokey'); setLoading(false); return; }
    fetch(`${API}/api/programmes/${slug}?key=${encodeURIComponent(key)}`)
      .then(r => { if (!r.ok) throw new Error(r.status === 403 ? 'denied' : 'notfound'); return r.text(); })
      .then(h => setHtml(h))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, [slug, key]);

  if (loading) return (
    <div style={{ minHeight: '100vh', backgroundColor: '#030014', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Loader2 size={28} className="animate-spin" style={{ color: '#00c8ff' }} />
    </div>
  );

  if (error) return (
    <div style={{ minHeight: '100vh', backgroundColor: '#030014', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center', maxWidth: 360 }}>
        {error === 'denied' || error === 'nokey' ? (
          <>
            <div style={{ width: 64, height: 64, borderRadius: 16, margin: '0 auto 20px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.15)' }}>
              <Lock size={26} style={{ color: '#ef4444' }} />
            </div>
            <h1 style={{ color: 'white', fontSize: 18, fontWeight: 700, marginBottom: 8, fontFamily: '"Space Grotesk", sans-serif' }} data-testid="programme-access-denied">Accès restreint</h1>
            <p style={{ color: '#6b7280', fontSize: 13 }}>Ce programme est protégé. Utilise le lien complet qui t'a été envoyé pour y accéder.</p>
          </>
        ) : (
          <>
            <ShieldAlert size={40} style={{ color: '#6b7280', margin: '0 auto 16px', display: 'block' }} />
            <h1 style={{ color: 'white', fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Programme introuvable</h1>
            <p style={{ color: '#6b7280', fontSize: 13 }}>Ce programme n'existe pas.</p>
          </>
        )}
      </div>
    </div>
  );

  return (
    <iframe
      srcDoc={html}
      title="Programme"
      data-testid="programme-iframe"
      style={{ width: '100%', height: '100vh', border: 'none', backgroundColor: '#030014' }}
    />
  );
}
